import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { AnyIfEmpty, useDispatch, useSelector } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import iconBathtub from '../../../src/images/icon-bathtub.svg';
import iconBed from '../../../src/images/icon-bed.svg';
import iconBack from '../../../src/images/icon-chevron-left.svg';
import iconDelete from '../../../src/images/icon-delete.svg';
import iconEdit from '../../../src/images/icon-edit.svg';
import iconFt from '../../../src/images/icon-ft.svg';
import { getAppointmentByUnitId, getUnitById, resetAppointments } from '../../redux/units/actions/unitById.action';
import CustModal from '../common/custmodal/CustModal';
import Loader from '../common/loader/Loader';
import RemoveModal from '../common/removeModal/RemoveModal';
import AddUnits from '../units/addunits/AddUnits';
import styles from './index.module.css';
import { useLocation } from 'react-router-dom';
import iconCopy from '../../images/icon-copy-3.svg';
import dollar from '../../images/icon-Dollar.svg';
import { getLocationById } from '../../redux/location/actions/location.action';
import { AppDispatch, IRootState } from '../../redux/rootReducer';
import Toast from '../common/toast/Toast';
import { SliderWithLightbox } from '../common/slider-with-lightbox/SliderWithLightbox';
import { hasPermission } from '../auth/login/Login';

interface upcomingVisitsData {
    id: React.Key | null | undefined;
    appointmentDate: moment.MomentInput;
    userName: string;
    startTime: string;
    endTime: string;
}

interface RecentVisitsProps {
    id: React.Key | null | undefined;
    appointmentDate: moment.MomentInput;
    userName: string;
    startTime: string;
    endTime: string;
}

const UnitDetails = () => {
    const [deletePopup, setDeletePopup] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [upcomingVisits, setUpcomingVisits]: AnyIfEmpty<object> = useState([]);
    const [recentVisits, setRecentVisits]: AnyIfEmpty<object> = useState([]);
    const [active, setActive] = useState('previous');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('delete');
    const [startIndex, setStartIndex] = useState(0);
    const [showLightBox, setShowLightBox] = useState(false);
    const baseUrl = import.meta.env.VITE_APP_VISITOR_URL;

    const canDeleteUnit = hasPermission('Properties & Units', 'Unit', 'delete');
    const canUpdateUnit = hasPermission('Properties & Units', 'Unit', 'update');

    const { id } = useParams();

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const { locationId, locationSearch, unitSearch } = useLocation().state;
    const unitId = useParams()?.id;

    const unitByIdData = useSelector((state: IRootState) => state.unitById.data.unit);
    const unitByIdLoader = useSelector((state: IRootState) => state.unitById.loading);
    const visits = useSelector((state: IRootState) => state.unitById.appointments.appointments);
    const loading = useSelector((state: IRootState) => state.units.unitsLoading);

    useEffect(() => {
        if (id) {
            dispatch(getUnitById(id));
            dispatch(getAppointmentByUnitId(id, true));
        }

        return () => {
            setRecentVisits([]);
            dispatch(resetAppointments());
        };
    }, [id]);

    useEffect(() => {
        if (locationId) {
            dispatch(getLocationById(locationId));
        }
    }, [locationId]);

    useEffect(() => {
        if (visits && visits.length > 0) {
            visits.map((visit: AnyIfEmpty<object>) => {
                if (visit.appointmentDate >= moment().format('YYYY-MM-DD')) {
                    setUpcomingVisits((prevData: any) => {
                        return [...new Set([...prevData, visit])];
                    });
                } else {
                    setRecentVisits((recentVisits: RecentVisitsProps[]) => {
                        return [...new Set([...recentVisits, visit])];
                    });
                }
            });
        }
    }, [visits]);

    const clickForLightboxHandler = (index: number) => {
        setStartIndex(index);
        setShowLightBox(true);
        document.body.classList.add('disable-scrolling');
    };

    const handleCopyLink = (url: string) => {
        navigator.clipboard
            .writeText(url)
            .then(() => {
                setShowToast(true);
                setToastMessage('Link copied to clipboard!');
                setToastType('success');
            })
            .catch(() => {
                setShowToast(true);
                setToastMessage('Failed to copy link.');
                setToastType('delete');
            });
    };

    return (
        <>
            {showToast && <Toast type={toastType ? toastType : 'delete'} message={toastMessage} />}

            <CustModal
                open={deletePopup}
                setOpen={setDeletePopup}
                bodyData={<RemoveModal type="Unit" setDeletePopup={setDeletePopup} unitId={unitByIdData?.id} locationId={locationId} />}
            />

            <CustModal
                open={editModal}
                setOpen={setEditModal}
                bodyData={
                    <AddUnits
                        locationId={unitByIdData?.location_id}
                        setShowToast={setShowToast}
                        setToastMessage={setToastMessage}
                        setOpen={setEditModal}
                        unitData={unitByIdData}
                        setToastType={setToastType}
                    />
                }
            />

            {unitByIdLoader || loading ? (
                <Loader />
            ) : (
                <div className={`${styles.outletConainer} unitDetailsSlider outletConainer`}>
                    <div className={styles.flexWrapper}>
                        <div className={styles.unitDetails}>
                            <div className={styles.unitDetailsRight}>
                                <div className={styles.flexContainer}>
                                    <div className={styles.cartDetailsHeader}>
                                        <div className={styles.cardTitleWrapper}>
                                            <div
                                                className={styles.cartDetailsBack}
                                                onClick={() =>
                                                    navigate(`/location/${locationId}`, {
                                                        replace: true,
                                                        state: { locationId: locationId, unitSearch: unitSearch, search: locationSearch },
                                                    })
                                                }>
                                                <img src={iconBack} />
                                            </div>
                                            <div>
                                                <h2 className={styles.cartDetailsPlace}>
                                                    {`${unitByIdData?.unitYardiId ? unitByIdData?.unitYardiId : unitByIdData?.name} ${unitByIdData?.nickName ? `"${unitByIdData?.nickName}"` : ''
                                                        } `}
                                                </h2>
                                                <p>
                                                    <span
                                                        className={styles.locationName}
                                                        onClick={() =>
                                                            navigate(`/location/${locationId}`, {
                                                                state: { unitSearch: unitSearch, search: locationSearch },
                                                            })
                                                        }>
                                                        {unitByIdData?.location_name}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        {unitByIdData?.unit_status !== 'deleted' && (
                                            <div className={styles.unitDetailsAction}>
                                                {canUpdateUnit && (
                                                    <div className={styles.iconedit}>
                                                        <img onClick={() => setEditModal(true)} src={iconEdit} alt="Edit" />
                                                    </div>
                                                )}
                                                {canDeleteUnit && (
                                                    <div className={styles.icondelete}>
                                                        <img onClick={() => setDeletePopup(true)} src={iconDelete} alt="Delete" />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.unitDetailsWrapper}>
                                <div className={styles.unitDetailsCarousel}>
                                    <SliderWithLightbox
                                        imgs={unitByIdData?.image_url && unitByIdData?.image_url?.split(',')}
                                        setShowLightBox={setShowLightBox}
                                        showLightBox={showLightBox}
                                        startIndex={startIndex}
                                        onClickHandler={clickForLightboxHandler}
                                    />
                                    <div
                                        className={`${styles.statusBadge} ${unitByIdData?.unit_status === 'available'
                                            ? styles.green
                                            : unitByIdData?.unit_status === 'occupied'
                                                ? styles.yellow
                                                : styles.red
                                            }`}>
                                        {unitByIdData?.unit_status === 'occupied' ? 'Occupied' : unitByIdData?.unit_status}
                                    </div>
                                </div>

                                {/* Unit details */}
                                <div className={styles.unitDetailsRight}>
                                    <div className={`${styles.beansUrl} ${styles.info}`}>
                                        <label>Unit Marketing Link</label>
                                        <div className={styles.url}>
                                            <img
                                                src={iconCopy}
                                                alt="copy-icon"
                                                onClick={() => handleCopyLink(`${baseUrl}/location/${locationId}/unit/${unitId}`)}
                                            />
                                            <span onClick={() => handleCopyLink(`${baseUrl}/location/${locationId}/unit/${unitId}`)}>
                                                Copy the unit marketing link to the property to your clipboard.
                                            </span>
                                        </div>
                                    </div>

                                    <div className={styles.facilities}>
                                        <div>
                                            <div className={styles.facility}>
                                                <div className={styles.facilityicon}>
                                                    <img src={iconFt} alt="Ft" />
                                                </div>
                                                <div className={styles.facilityName}>{unitByIdData?.size} Sq Ft</div>
                                            </div>
                                            <div className={styles.facility}>
                                                <div className={styles.facilityicon}>
                                                    <img src={iconBed} alt="Beds" />
                                                </div>
                                                {Number(unitByIdData?.rooms) !== 0 && Number(unitByIdData?.rooms)}{' '}
                                                {Number(unitByIdData?.rooms) === 1
                                                    ? 'Bed'
                                                    : Number(unitByIdData?.rooms) === 0
                                                        ? 'Studio'
                                                        : 'Beds'}
                                            </div>
                                            <div className={styles.facility}>
                                                <div className={styles.facilityicon}>
                                                    <img src={iconBathtub} alt="Bathtubs" />
                                                </div>
                                                <div className={styles.facilityName}>
                                                    {(+unitByIdData?.baths || +unitByIdData?.baths === 0) && (
                                                        <span>{`${+unitByIdData?.baths} ${+unitByIdData?.baths === 1 ? 'Bath' : 'Baths'
                                                            }`}</span>
                                                    )}
                                                </div>
                                            </div>

                                            {!!unitByIdData?.price && (
                                                <div className={styles.facility}>
                                                    <div className={`${styles.facilityicon} ${styles.priceSection}`}>
                                                        <img className={styles.dollarImg} src={dollar} alt="price" />
                                                    </div>
                                                    <div className={styles.facilityName}>
                                                        <span>{unitByIdData?.price}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {unitByIdData?.buildingName && (
                                        <div className={styles.inlineItems}>
                                            <label>Building: </label>
                                            <p>{unitByIdData?.buildingName}</p>
                                        </div>
                                    )}

                                    {unitByIdData?.description && (
                                        <div className={styles.info}>
                                            <label>Description:</label>
                                            <p>{unitByIdData?.description}</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className={styles.btnContainer}>
                                <ul>
                                    <li>
                                        <button
                                            onClick={() => setActive('previous')}
                                            className={active === 'previous' ? styles.btnGreen : styles.btnOutlineBlack}>
                                            Previous Visits
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.tableContainer}>
                                {
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th>Date</th>
                                                <th>Visitor Name</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                            </tr>
                                            {active === 'upcoming' && upcomingVisits.length === 0 && (
                                                <tr>
                                                    <td colSpan={4} style={{ textAlign: 'center' }}>
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}

                                            {active === 'upcoming' &&
                                                upcomingVisits?.length > 0 &&
                                                upcomingVisits?.map((data: upcomingVisitsData) => {
                                                    return (
                                                        <>
                                                            <tr key={data.id}>
                                                                <td>{moment(data.appointmentDate).utc().format('MM-DD-YYYY')}</td>
                                                                <td>{data.userName}</td>
                                                                <td>{moment(data.startTime, 'hh:mm A').format('h:mm A')}</td>
                                                                <td>{moment(data.endTime, 'hh:mm A').format('h:mm A')}</td>
                                                            </tr>
                                                        </>
                                                    );
                                                })}

                                            {active === 'previous' && recentVisits.length === 0 && (
                                                <tr>
                                                    <td colSpan={4} style={{ textAlign: 'center' }}>
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}

                                            {active === 'previous' &&
                                                recentVisits.length > 0 &&
                                                recentVisits?.map((data: upcomingVisitsData) => {
                                                    return (
                                                        <tr key={data.id}>
                                                            <td>{moment(data.appointmentDate).locale('en').format('MM-DD-YYYY')}</td>
                                                            <td>{data.userName}</td>
                                                            <td>{moment(data.startTime, 'hh:mm A').format('h:mm A')}</td>
                                                            <td>{moment(data.endTime, 'hh:mm A').format('h:mm A')}</td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UnitDetails;
